export default __webpack_public_path__ + "static/media/1-warranty.523865b7.svg";